import axiosInstance from "./AxiosInstance";

export function getPartsRepairList(data) {
  return axiosInstance.post(`/parts-repair/list`, data);
}

export function getPartsRepairHistoryList(data) {
  return axiosInstance.post(`/parts-repair/get-part-history-data`, data);
}


export function getPartsRepairHistoryDetailsList(data) {
  return axiosInstance.post(`/parts-repair/get-vehicle-part-history`, data);
}



